import type { Mutation } from "@tanstack/react-query";

// Matches personSidebarRow mutations so the settle-time refetch counts only the sidebar's own
// writes, not an unrelated mutation elsewhere in the app.
export const isSidebarMutation = (mutation: Mutation<unknown, unknown, unknown, unknown>): boolean => {
  const path = mutation.options.mutationKey?.[0];
  return Array.isArray(path) && path[0] === "personSidebarRow";
};
